/* eslint-disable import/no-extraneous-dependencies */
import { call, put, takeLatest } from 'redux-saga/effects';

import { axiosMicro } from '~/services';
import * as Actions from './actions';

function* getAllOrdersList({ payload }) {
  try {
    const response = yield call(
      typeof payload === 'string'
        ? () => axiosMicro.get(`/orders?${payload}`)
        : () => axiosMicro.get('/orders', { params: payload }),
    );
    yield put(Actions.getAllOrdersListSuccess(response.data));
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.getAllOrdersListFailure(messages));
    }
  }
}

function* createOrderReturn({ payload }) {
  try {
    yield call(() => axiosMicro.post('/order-returns', payload.dataPayload));
    yield put(Actions.createOrderReturnSuccess(payload.dataUpdated));
  } catch (error) {
    if (error?.response?.data) {
      const messages = error.response.data;
      yield put(Actions.createOrderReturnFailure(messages));
    }
  }
}

function* getOrderForWarehouse({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get('/warehouses/get-orders', {
      params: payload,
    }));
    yield put(Actions.getOrderForWarehouseSuccess(response.data));
  } catch (error) {
    if (error.response?.data) {
      const messages = error.response.data;
      yield put(Actions.getOrderForWarehouseFailure(messages));
    }
  }
}

// eslint-disable-next-line func-names
export default function* () {
  yield takeLatest(Actions.getAllOrdersListRequest, getAllOrdersList);
  yield takeLatest(Actions.createOrderReturnRequest, createOrderReturn);
  yield takeLatest(Actions.getOrderForWarehouseRequest, getOrderForWarehouse);
}
